import ComponentOutlet from '../storyblok/ComponentOutlet';

function ConditionalSwitch({ body }) {
	return <ComponentOutlet components={body} switch />;
}
export default ConditionalSwitch;
